import { UsePlanAnualContext } from "#training/contexts/AnnualPlanCreateContext"
import { Divider, Paper, Stack, Typography } from "@mui/material"
import Box from "@mui/material/Box"
import Checkbox from "@mui/material/Checkbox"
import FormControl from "@mui/material/FormControl"
import FormControlLabel from "@mui/material/FormControlLabel"
import FormGroup from "@mui/material/FormGroup"
import List from "@mui/material/List"
import ListItem from "@mui/material/ListItem"
import ListItemText from "@mui/material/ListItemText"
import ListSubheader from "@mui/material/ListSubheader"
import Grid from "@mui/material/Unstable_Grid2/Grid2"
import { Fragment, useMemo } from "react"
import AnnualPlanCreateCursos from "./AnnualPlanCreateCursos"

export default function AnnualPlanCreateAreas() {
	return (
		<Box
			sx={{
				display: "flex",
				width: "100%",
			}}
		>
			<Grid
				sx={{
					width: "100%",
				}}
				container
				spacing={1}
			>
				<Grid xs={5}>
					<Stack spacing={2}>
						<CheckAreas />
						<ListPersonally />
					</Stack>
				</Grid>
				<Grid xs={7}>
					<AnnualPlanCreateCursos />
				</Grid>
			</Grid>
		</Box>
	)
}
const CheckAreas = () => {
	const { areas, selectAreas, setSelectAreas } = UsePlanAnualContext()

	const handleChange = (event) => {
		const targetBox = event.target.closest("[id]")
		if (!targetBox) return

		const areaId = parseInt(targetBox.id)
		if (selectAreas.includes(areaId)) {
			setSelectAreas(selectAreas.filter((item) => item !== areaId))
		} else {
			setSelectAreas((old) => [...old, areaId])
		}
	}
	return (
		<Box component={Paper} width={"100%"}>
			<Typography textAlign="center" pt={1} mb={1} variant="h6">
				Departamentos
			</Typography>
			<Divider />

			<FormControl sx={{ width: "100%" }}>
				<FormGroup>
					<Stack
						p={"8px"}
						spacing={1}
						mt={2}
						sx={{
							maxHeight: "28vh",
							overflow: "auto",
						}}
						width={"100%"}
					>
						{areas.map((area) => {
							return (
								<Box
									id={area.id}
									key={area.id}
									component={Paper}
									width={"100%"}
								>
									<FormControlLabel
										id={area.id}
										sx={{ width: "100%" }}
										label={
											<Typography
												width={"100%"}
												color={
													area.annual_plan.exists
														? "gray"
														: "black"
												}
											>
												{`${area.description} : colaboradores [${area.collaborators.count}]`}
											</Typography>
										}
										control={
											<Checkbox
												disabled={area.annual_plan.exists}
												checked={selectAreas.includes(area.id)}
												id={area.id}
												name={`${area.description}`}
												onClick={handleChange}
											/>
										}
									/>
								</Box>
							)
						})}
					</Stack>
				</FormGroup>
			</FormControl>
		</Box>
	)
}

export function ListPersonally({ data }) {
	const { areas, selectAreas } = UsePlanAnualContext()
	const collaborator = useMemo(() => {
		return areas.filter((item) => selectAreas.includes(item.id))
	}, [areas, selectAreas])

	if (!collaborator.length) return null

	return (
		<Box component={Paper} width={"100%"}>
			<List
				sx={{
					maxHeight: "30vh",
					overflow: "auto",
				}}
				subheader={<li />}
			>
				{collaborator.map((area) => {
					return (
						<Box component={Paper} width={"100%"}>
							<ListSubheader>
								<Typography
									pt={1}
									variant="h6"

									// sx={{ bgcolor: COLOR_PRIMARY, color: COLOR_WHITE }}
								>
									{`${area.description} : ${area.collaborators.count}`}
								</Typography>
							</ListSubheader>

							{area.collaborators.data.map((item) => (
								<Fragment>
									<ListItem key={`item-${area?.id}-${item["id"]}`}>
										<ListItemText primary={`${item["name"]}`} />
									</ListItem>
									<Divider component="li" />
								</Fragment>
							))}
							{/* </ul> */}
						</Box>
					)
				})}
			</List>
		</Box>
	)
}
